import type React from 'react';
import styles from './LoggedInContentWrapper.module.css';

interface LoggedInContentWrapperProps {
  title: string;
  children: React.ReactNode;
}

const LoggedInContentWrapper: React.FC<LoggedInContentWrapperProps> = ({
  title,
  children,
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>{title}</h1>
      </div>
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default LoggedInContentWrapper;
